<template>
  <div class="footer text_ctr">
    <div class="txts">
      科技部西南信息中心 · 重庆尚唯信息技术有限公司 联系我们<br />
      地址：重庆北部新区黄山大道中段5号水星大厦B座 邮政编码：4011121 免费电话：400-636-0093<br />
      增值电信业务经营许可证: 渝B2-20220077<br />
      渝ICP备17012494号-1 您的IP地址:014.104.083.222
    </div>
  </div>
</template>
<script>
export default {
  name: "WorkspaceJsonFooter",
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
    
  },
  updated() {

  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  // height: 200px;
  background: url('~@/assets/imgs/header/footer-bg.png') no-repeat;
  background-size:100% 100%;
  .txts {
    padding: 52px  0;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #F5F5F6;
    line-height: 24px;
  }
}
</style>